import { Model, belongsTo } from 'miragejs';
import attr from 'ember-data/attr';

export default Model.extend({
  floor: belongsTo('graphql/map-floor'),

  name: attr('string'),
  notes: attr('string'),
  enabled: attr('boolean'),
  type: attr('string'),
});
